import React from "react";
import "./Ourservice.css";
import { Routes, Route, Link } from "react-router-dom";

const Ourservice = () => {
  const services = [
    {
      id: 1,
      icon: "fas fa-utensils",
      title: "ClickaCook",
      route: "/clickacook",
      Active: true,
      description:
        "Your Personal Cook – Anytime- Anywhere.Revolutionizing home dining, ClickaCook connects skilled home cooks with food lovers seeking authentic, homemade meals — freshly prepared in your kitchen. Whether it’s daily dining or special occasions, we make every meal personal, effortless, and delicious.",
      gradient: "linear-gradient(135deg, #ff6b6b, #ffa726)",
      features: [
        "Verified Home Cooks",
        "Custom Meal Plans & Dietary Options",
        "Real-Time Order Tracking",
        "Hygiene & Quality Assurance",
      ],
    },
    {
      id: 2,
      icon: "fas fa-globe-americas",
      title: "World Trade",
      Active: false,
      link: "/",
      description:
        "Global Trade. Local Trust.Our World Trade division simplifies international commerce with end-to-end import and export solutions. From logistics and compliance to sourcing and payment integration, we enable businesses to expand confidently across borders — efficiently, transparently, and sustainably.",
      gradient: "linear-gradient(135deg, #4ecdc4, #44a08d)",
      features: [
        "Sourcing and Supplier Onboarding",
        "Contracting & CLM",
        "Global Logistics & Freight Management",
        "Trade Compliance & Documentation",
        "Market Research & Partner Sourcing",
        "Secure Payment & Settlement Solutions",
      ],
    },
    {
      id: 3,
      icon: "fas fa-bullhorn",
      title: "Training & Consultancy",
      Active: false,
      description:
        "Our Training & Consultancy division equips individuals and organizations with the knowledge, skills, and insights needed to excel in an evolving global landscape.Through expert-led programs, leadership coaching, and strategic advisory, we transform potential into performance and ideas into impact.",
      gradient: "linear-gradient(135deg, #fdbb2d, #b21f1f)",
      features: [
        "AI in Sourcing and Procurement",
        "AI in Human Resources Management",
        "AI in Office administration",
        "AI in Business Development",
        "Cyber Security and forensics",
        "AI in Quality Management",
      ],
    },
    {
      id: 4,
      icon: "fas fa-hammer",
      title: "Integrated Facility Management Services",
      route: "/IFMS_Home",
      Active: true,
      description:
        "Our expert team is here to ensure your properties are well-maintained, efficient, and secure. Contact us today for exceptional facility management solutions!",
      gradient: "linear-gradient(135deg, #fdbb2d, #b21f1f)",
      features: [
        "Cleaning Services",
        "Support Services",
        "Property Services",
        "Catering Services",
        "Security Services",
      ],
    },
  ];

  return (
    <section id="divisions" className="services-section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">What We Offer</span>
          <h2 className="section-title">Our Premium Services</h2>
          <p className="section-description">
            We deliver innovative solutions that drive growth and transform
            businesses. Our comprehensive services are designed to meet your
            unique needs and exceed expectations.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div
                className="service-icon"
                style={{
                  background: service.gradient,                }}
              >
                <i className={service.icon}></i>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <i className="fas fa-check-circle"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              {/* // Replace the button with: */}
              <Link
                target="_blank"
                to={service.route}
                className="service-cta"
                style={{ background: service.gradient ,display:service.Active?"Block":"None"}}
              >
                Learn More
                <i className="fas fa-arrow-right"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>Ready to Transform Your Business?</h3>
            <p>
              Let's discuss how our services can help you achieve your goals
            </p>
            <div className="cta-buttons">
              <button className="btn-primary">Get Started Today</button>
              <button className="btn-secondary">Schedule a Consultation</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ourservice;
